import { getEventsLocation } from '../../../../ui-kitchen/src/api/api';
import Logger from '../../../../ui-kitchen/src/utils/logger';

angular
  .module('resyApp')
  .service('ResyEvents', ResyEvents);

function ResyEvents($q) {
  /* eslint-disable camelcase */
  const eventsObj = {};

  const eventsByLocation = async ({
    locationId, limit, startDate, filter_exclusive,
  }) => {
    const deferred = $q.defer();
    const payload = {
      location_id: locationId,
      limit,
      start_date: startDate || new Date().toISOString().split('T')[0],
      filter_exclusive,
    };

    const dataKey = `${locationId}_${limit}_${startDate}_${filter_exclusive}`;

    if (eventsObj[dataKey]) {
      deferred.resolve(eventsObj[dataKey]);
    } else {
      getEventsLocation(payload)
        .then((eventList) => {
          eventsObj[dataKey] = eventList;
          deferred.resolve(eventList);
        })
        .catch((err) => {
          Logger.error('[ResyEvents] eventsByLocation Error:', err);
        });
    }

    return deferred.promise;
  };

  return {
    eventsByLocation,
  };
}

export default () => {};
